import {Injectable} from '@angular/core';
import {SecureStorageService} from './secure-storage.service';
import {isNil} from "lodash-es";

@Injectable({
  providedIn: 'root',
})
export class SecureLocalService {
  constructor(private storageService: SecureStorageService) {
  }

  setItem(key: string, value: any) {
    this.storageService.secureStorage.setItem(key, value);
  }

  geItem(key: string) {
    return this.storageService.secureStorage.getItem(key);
  }

  removeItem(key: string) {
    return this.storageService.secureStorage.removeItem(key);
  }

  clear() {
    this.storageService.secureStorage.clear();
  }

  getUserOrganizations(orgId?: number) {
    let userOrganizations = this.geItem('vibaUserOrganizations');
    if (orgId) {
      return userOrganizations.filter(org => org !== orgId);
    }
    return userOrganizations;
  }

  isNotAnAgent() {
    let agentData = this.geItem('web-rtc-agent-data');
    return isNil(agentData);
  }

  tokenExpired() {
    try {
      const token = localStorage.getItem('authToken');
      if (token) {
        const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
        return (Math.floor((new Date).getTime() / 1000)) >= expiry;
      }
    } catch (e) {
      return true;
    }
    return true;

  }
}

export enum AGENT_TYPE {
  NOT__AGENT = 0,
  WEB_AGENT = 1,
}
